import * as React from "react";

import styles from "./ScrollTracker.module.scss";

export interface ExampleCarouselImageProps {
  title: string;
  text: string;
  number: string;
}

const TrackerCard: React.FC<ExampleCarouselImageProps> = ({ title, text, number }) => (
  <div className={styles["tracker-card-wrapper"]}>
    <h3 className="pb-5">{number}</h3>
    <div className={styles["card-lines-wrapper"]}>
      <div className={styles["starting-line"]} />
      <div className={styles["trailing-line"]} />
      <div className={styles["trailing-line"]} />
      <div className={styles["trailing-line"]} />
      <div className={styles["trailing-line"]} />
    </div>
    <div className={styles["card-text-wrapper"]}>
      <div className="h4 mb-3">{title}</div>
      <div className="b3">{text}</div>
    </div>
  </div>
);

export default TrackerCard;
